function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgBrowser = function SvgBrowser(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Browser' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M0,41 L0,0 L48,0 L48,41 L0,41 Z M2,10 L46,10 L46,2 L2,2 L2,10 Z M2,39 L46,39 L46,12 L2,12 L2,39 Z"
  }), React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, React.createElement("path", {
    d: "M2,4 C3.104,4 4,3.104 4,2 C4,0.895 3.104,0 2,0 C0.896,0 0,0.895 0,2 C0,3.104 0.896,4 2,4"
  }), React.createElement("path", {
    d: "M8,4 C9.104,4 10,3.104 10,2 C10,0.895 9.104,0 8,0 C6.896,0 6,0.895 6,2 C6,3.104 6.896,4 8,4"
  }), React.createElement("path", {
    d: "M14,4 C15.104,4 16,3.104 16,2 C16,0.895 15.104,0 14,0 C12.896,0 12,0.895 12,2 C12,3.104 12.896,4 14,4"
  })));
};

SvgBrowser = pure(SvgBrowser);
SvgBrowser.displayName = 'SvgBrowser';
export default SvgBrowser;